// The `archive` widget: which uploaded .zip a route pack serves.
//
// Named by `fileId` on @common/schema/site-pack/fields, and by nothing else.
//
// WHY IT IS A BUTTON AND A READ-ONLY BOX, WHERE ../url IS AN EDITABLE ONE
//
// `url` stays a text box because every field it sits on legitimately accepts a
// URL that was never uploaded here — a favicon on a CDN, somebody else's
// image. There is no such value for this field. A pack's `fileId` names a row
// in THIS site's Documents; a hand-typed one is either a copy of something the
// picker would have offered or a string the model refuses
// (`site-pack.archive.notfound`). So the box shows what is attached and the
// button is the only way to change it — a typo here is not a thing worth
// supporting.
//
// The picker is ../../components/archive-selector rather than
// ../../components/file-selector, and that file's header says why at length:
// the image picker gates on `isPreviewExt`, hands back a public URL and
// publishes the row on select, and all three are wrong for an archive.
import React from "react";
import { Input, Button } from "reactstrap";
import * as ArchiveSelector from "components/archive-selector";

export const View = ({ value }) => <span>{value}</span>;

export const Edit = (props) => {
  const {
    value,
    setValue,
    field: { name, property = {}, config = {} } = {},
    labelId,
    describedById,
  } = props;

  const readOnly = Boolean(config.readOnly || property.readOnly);

  return (
    <div className="input-group">
      <Input
        name={name}
        type="text"
        // What names the box: the form's label and description, by the ids the
        // object widget hands in — the same two attributes every built-in
        // widget sets. Read-only or not, it is the element that says which
        // archive is attached, so it is the one that gets the field's name.
        aria-labelledby={labelId}
        aria-describedby={describedById}
        readOnly
        // The id, not a filename. The row's name is one click away on the
        // Files screen, and showing it here would mean either carrying it on
        // the pack row — a second copy of something that can be renamed — or a
        // query per render to resolve a string the form already holds.
        value={value || ""}
        placeholder="No archive attached"
      />

      {!readOnly && (
        <div className="input-group-append">
          <ArchiveSelector.SelectButton
            onSelect={(file) => {
              setValue(file.fileId);
            }}
          >
            {value ? "Change" : "Select"}
          </ArchiveSelector.SelectButton>

          {/* Detaching is the only way to take a mount down without deleting
              the pack: the model derives `status` from this field, so clearing
              it puts the row back to PENDING and the resolver stops
              intercepting the route. Offered only when there is one to
              detach. */}
          {value && (
            <Button
              type="button"
              color="secondary"
              onClick={(e) => {
                e.preventDefault();
                setValue("");
              }}
            >
              Detach
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
